export default "__VITE_ASSET__C$Eaw4F9__"